import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { ListingForm } from "components/shared/TableListing/types";
import { InvoiceDescriptionCell } from "./InvoiceDescriptionCell";
import { EquipmentDescriptionCell } from "./EquipmentDescriptionCell";
import { generateAvailableItemsForAttach } from "../../../../../lib";
import { QuoteChargeListingEntity, QuoteChargeType } from "../../../../../types";

interface Props {
  rowIndex: number;
  onRemoveRow: VoidFunction;
  onUnLinkCharge: VoidFunction;
  onEditEquipment: (id: string, rowIndex: number) => void;
  onRemoveEquipment: (id: string, rowIndex: number) => void;
  onLinkCharge: (attachId: string, linkIndex: number) => void;
}

export const DescriptionCell = ({
  rowIndex,
  onRemoveRow,
  onLinkCharge,
  onUnLinkCharge,
  onEditEquipment,
  onRemoveEquipment,
}: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();
  const rows = useWatch({ control, name: `bodyFields` });

  const { type, charge, equipment } = rows[rowIndex];
  const itemsForAttach = generateAvailableItemsForAttach(rows);

  const renderCellContentByType = {
    [QuoteChargeType.Invoice]: (
      <InvoiceDescriptionCell
        charge={charge!}
        onRemoveRow={onRemoveRow}
        onLinkCharge={onLinkCharge}
        onUnLinkCharge={onUnLinkCharge}
        itemsForAttach={itemsForAttach}
      />
    ),
    [QuoteChargeType.Equipment]: (
      <EquipmentDescriptionCell
        equipment={equipment}
        onEditEquipment={id => onEditEquipment(id, rowIndex)}
        onRemoveEquipment={id => onRemoveEquipment(id, rowIndex)}
      />
    ),
  };

  return <>{renderCellContentByType[type]}</>;
};
